import axios from "axios"
import { escapeCharacters } from "src/sites/text/AiTextTranslatorPage"

interface TranslateSuppParams {
  langFrom: string,
  langTo: string
}
interface DetectedLanguage {
  lang: string,
  prob: number
}

interface TranslationRequest {
  text: string
  langFrom: string
  langTo: string
  genre: string
  taxonomy: string
}

const ENDPOINT_PREFIX = "/api/snc/"

export async function translateAssetPost(req: TranslationRequest): Promise<TranslatedAsset> {
  const url = ENDPOINT_PREFIX + "translate"
  // Normalize language codes to lowercase
  const normalizedReq = {
    ...req,
    langFrom: req.langFrom.toLowerCase(),
    langTo: req.langTo.toLowerCase()
  }
  const translatedAsset = (await axios.post(url, normalizedReq)).data[0]
  return { ...translatedAsset, targetText: escapeCharacters(translatedAsset.targetText, true) }
}

export interface TranslatedAsset {
  engine?: string,
  recycled?: boolean,
  sourceText: string,
  anonymizedSourceText?: string,
  targetText: string,
  anonymizedTargetText?: string,
  langFrom: string,
  langTo: string,
  tokens: [],
  taxonomy?: string
}

interface PersistTranslatedAssetRequest {
  engine?: string,
  recycled?: boolean,
  sourceText: string,
  anonymizedSourceText?: string,
  targetText: string,
  anonymizedTargetText?: string,
  langFrom: string,
  langTo: string,
  tokens: [],
  taxonomy?: string
  mtTargetText?: string
  anonymizedMtTargetText?: string
}

export async function persist(req: PersistTranslatedAssetRequest): Promise<string> {
  const url = ENDPOINT_PREFIX + "translate/persist"
  // Normalize language codes to lowercase
  const normalizedReq = {
    ...req,
    langFrom: req.langFrom.toLowerCase(),
    langTo: req.langTo.toLowerCase()
  }
  return await axios.post(url, normalizedReq)
}

export async function isTranslationSupported(langFrom: string, langTo: string): Promise<boolean> {
  const url = ENDPOINT_PREFIX + "engineAvailability"
  const params: TranslateSuppParams = {
    langFrom: langFrom.toLowerCase(),
    langTo: langTo.toLowerCase()
  }
  const resp = await axios.get(url, { params })
  return (!!resp.data && resp.data.length > 0)
}

export const detectLanguage = (text: string) => axios.post<DetectedLanguage[]>(ENDPOINT_PREFIX + `detectLanguage`, text)
